{
  "user": {
    "form": {
      "addTitle": "创建用户",
      "editTitle": "编辑用户",
      "fields": {
        "username": "用户名",
        "email": "电子邮箱",
        "fullName": "姓名",
        "password": "密码",
        "confirmPassword": "确认密码",
        "facility": "机构",
        "roles": "角色",
        "active": "启用",
        "allFacilities": "所有机构（全医疗系统）",
        "globalAccessAck": "我了解此设置将授予访问所有机构的权限",
        "departments": "科室",
        "primaryDepartment": "主科室",
        "roleFacility": "{{role}} 的机构",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ 添加机构",
        "removeFacilityFromRole": "移除一个",
        "otherRoles": "其他"
      },
      "errors": {
        "usernameMin": "用户名至少需要 {{min}} 个字符",
        "emailInvalid": "电子邮箱格式无效",
        "passwordMin": "密码至少需要 {{min}} 个字符",
        "confirmPasswordRequired": "请确认密码",
        "passwordMismatch": "两次输入的密码不一致",
        "rolesRequired": "至少需要选择一个角色",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "保存前请确认全医疗系统授权。"
      },
      "submit": {
        "create": "创建用户",
        "update": "更新用户"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "用户创建成功",
        "updatedSuccess": "用户更新成功",
        "saveError": "保存用户失败",
        "departmentsSaveError": "用户已保存，但科室分配失败。请编辑该用户重试。"
      },
      "globalAccessWarning": "此设置将授予访问“每一家”机构患者的权限，而不仅仅是呼叫范围。请仅用于真正覆盖全医疗系统的人员，例如值班人员。",
      "departmentsHint": "该账户的工作科室。仅用于记录归属，不授予任何患者访问权限。",
      "noDepartments": "尚未配置任何科室。"
    },
    "list": {
      "title": "用户管理",
      "subtitle": "管理系统用户、角色与访问权限",
      "columns": {
        "username": "用户名",
        "fullName": "姓名",
        "email": "电子邮箱",
        "roles": "角色",
        "facility": "机构",
        "status": "状态",
        "lastLogin": "上次登录",
        "actions": "操作",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "搜索用户...",
        "allRoles": "全部角色",
        "allFacilities": "全部机构",
        "allStatus": "全部状态",
        "active": "启用",
        "inactive": "停用"
      },
      "actions": {
        "new": "创建用户",
        "editTitle": "编辑用户",
        "resetPasswordTitle": "重置密码",
        "activate": "启用",
        "deactivate": "停用",
        "activateAria": "启用用户",
        "deactivateAria": "停用用户"
      },
      "lastLoginNever": "从未",
      "empty": "未找到符合筛选条件的用户",
      "pagination": {
        "summary": "显示 {{from}}-{{to}}，共 {{total}} 条"
      },
      "toast": {
        "activated": "用户 {{username}} 已启用",
        "deactivated": "用户 {{username}} 已停用",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "所有机构",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "启用",
      "inactive": "停用",
      "locked": "已锁定",
      "pendingActivation": "待激活"
    },
    "mfaStatus": {
      "enrolled": "已注册",
      "notEnrolled": "未注册",
      "exempt": "豁免"
    }
  },
  "role": {
    "form": {
      "addTitle": "创建角色",
      "editTitle": "编辑角色",
      "fields": {
        "name": "角色名称",
        "code": "角色代码",
        "description": "描述",
        "category": "分类",
        "parentRole": "父角色（继承权限）"
      },
      "options": {
        "none": "无"
      },
      "errors": {
        "nameRequired": "角色名称不能为空",
        "codeRequired": "角色代码不能为空"
      },
      "submit": {
        "create": "创建角色",
        "update": "更新角色"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "角色创建成功",
        "updatedSuccess": "角色更新成功",
        "saveError": "保存角色失败"
      }
    },
    
    "status": {
      "active": "启用",
      "inactive": "停用"
    },
    "source": {
      "own": "自有",
      "inherited": "继承",
      "category": "分类"
    },
    "permissions": {
      "ownTitle": "编辑权限",
      "deniedTitle": "编辑拒绝权限",
      "ownSubtitle": "已授予 {{granted}}/{{total}}。继承及分类默认权限显示在访问矩阵中；本页面仅管理该角色自身的授权。",
      "deniedSubtitle": "拒绝权限会覆盖来自角色自身、父角色及分类默认的所有授权。勾选权限以为该角色显式拒绝。",
      "invalidRoleId": "角色 ID 无效。",
      "save": "保存权限",
      "saveDenied": "保存拒绝权限",
      "cancel": "取消",
      "toast": {
        "updatedSuccess": "权限已更新",
        "deniedUpdatedSuccess": "拒绝权限已更新",
        "saveError": "保存权限失败",
        "saveDeniedError": "保存拒绝权限失败"
      },
      "permissionGroup": {
        "analytics": "分析",
        "audit": "审计",
        "billing": "计费",
        "bloodProduct": "血液制品",
        "consent": "知情同意",
        "dietOrder": "饮食医嘱",
        "discharge": "出院",
        "documentation": "记录",
        "encounter": "就诊",
        "infection": "感染控制",
        "licensing": "授权管理",
        "medication": "药物",
        "notification": "通知",
        "order": "医嘱",
        "patient": "患者",
        "referral": "转诊",
        "research": "研究",
        "restraint": "约束",
        "result": "结果",
        "scheduling": "排班",
        "system": "系统",
        "transfer": "转科",
        "user": "用户",
        "schedule": "排班",
        "admin": "管理",
        "report": "报告",
        "other": "其他"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "创建分类",
      "editTitle": "编辑分类",
      "fields": {
        "name": "分类名称",
        "code": "分类代码",
        "description": "描述",
        "sessionTimeout": "会话超时（分钟）",
        "maxFailedLogins": "最大登录失败次数",
        "mfaRequired": "本分类需要 MFA"
      },
      "placeholders": {
        "code": "例如 CLINICAL"
      },
      "errors": {
        "nameRequired": "分类名称不能为空",
        "codeRequired": "分类代码不能为空"
      },
      "submit": {
        "create": "创建分类",
        "update": "更新分类"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "分类创建成功",
        "updatedSuccess": "分类更新成功",
        "saveError": "保存分类失败"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "无",
      "basic": "基础",
      "full": "完整",
      "paranoid": "严格"
    },
    "permissions": {
      "title": "默认权限",
      "titleWithName": "默认权限 — {{name}}",
      "subtitle": "该分类下的角色将继承这些权限，除非显式拒绝。",
      "invalidCategoryId": "分类 ID 无效。",
      "save": "保存默认权限",
      "cancel": "取消",
      "toast": {
        "updatedSuccess": "默认权限已更新",
        "saveError": "保存默认权限失败"
      }
    }
  },
  "permission": {
    "action": {
      "view": "查看",
      "viewSelf": "仅查看本人",
      "viewRestricted": "受限查看",
      "read": "读取",
      "write": "写入",
      "create": "创建",
      "update": "更新",
      "modify": "修改",
      "delete": "删除",
      "merge": "合并",
      "discharge": "出院",
      "transfer": "转科",
      "approve": "审批",
      "cosign": "共同签署",
      "sign": "签署",
      "plan": "计划",
      "manage": "管理",
      "all": "全部",
      "breakGlass": "紧急访问",
      "export": "导出",
      "amend": "修订",
      "administer": "执行",
      "doubleCheck": "双人复核",
      "reconcile": "用药核对",
      "verbalVerify": "口头医嘱确认",
      "verify": "审核",
      "acknowledge": "确认",
      "prescribe": "开方",
      "dispense": "调剂",
      "cancel": "取消",
      "users": "用户",
      "roles": "角色",
      "facilities": "机构",
      "system": "系统",
      "audit": "审计日志"
    }
  },
  "access": {
    "title": "访问权限矩阵",
    "subtitle": "角色 × 权限对照表",
    "searchPermission": "搜索权限…",
    "searchRole": "搜索角色…",
    "categoryFilter": "类别",
    "legend": {
      "own": "自有",
      "inherited": "继承",
      "category": "类别",
      "denied": "已拒绝",
      "none": "无"
    },
    "cellTooltip": {
      "hasOwn": "直接授予",
      "hasInherited": "继承自父角色：{{source}}",
      "hasCategory": "通过类别授予：{{source}}",
      "denied": "已明确拒绝",
      "none": "未授予"
    },
    "inheritedFrom": "继承自 {{source}}",
    "bulkEdit": {
      "title": "批量编辑",
      "applyTo": "应用于所选项",
      "selectedPermissions": "{{count}} 项权限",
      "selectedRoles": "{{count}} 个角色",
      "actionGrant": "授予",
      "actionDeny": "拒绝",
      "actionClear": "清除",
      "save": "保存更改",
      "cancel": "取消"
    },
    "emptyRoles": "没有符合筛选条件的角色。",
    "emptyPermissions": "没有符合筛选条件的权限。",
    "loading": "正在加载访问权限矩阵…",
    "permissionColumn": "权限",
    "rolePicker": {
      "trigger": "选择要对比的角色",
      "filterPlaceholder": "筛选角色…",
      "empty": "没有匹配的角色。",
      "groupAll": "全部",
      "groupNone": "无",
      "footerSummary": "已选 {{count}} / {{total}}",
      "selectAll": "全选",
      "clear": "清除"
    },
    "empty": {
      "selectRolesPrompt": "请至少选择一个角色进行对比。",
      "selectAllRoles": "选择全部角色",
      "noPermissions": "未找到权限。"
    },
    "legendCategoryDefault": "类别默认",
    "legendNotGranted": "未授予",
    "page": {
      "title": "访问权限矩阵",
      "subtitle": "查看与管理角色、权限和访问策略"
    },
    "tabs": {
      "matrix": "访问权限矩阵",
      "roles": "角色管理",
      "categories": "类别管理"
    },
    "roles": {
      "searchPlaceholder": "搜索角色或权限...",
      "createButton": "创建角色",
      "columns": {
        "role": "角色",
        "category": "类别",
        "parent": "父角色",
        "permissions": "权限",
        "users": "用户",
        "actions": "操作"
      },
      "systemBadge": "系统",
      "managePermissionsTitle": "管理权限",
      "manageDeniedTitle": "管理拒绝权限",
      "deniedBadge": "已拒绝",
      "editTitle": "编辑角色",
      "deleteTitle": "删除角色",
      "expandAria": "展开角色",
      "collapseAria": "收起角色",
      "effectivePermissions": "有效权限",
      "noPermissionsAssigned": "未分配任何权限。",
      "empty": "未找到角色。",
      "delete": {
        "title": "删除角色",
        "description": "确定要删除角色「{{name}}」吗?此操作无法撤销。",
        "confirm": "删除"
      },
      "toast": {
        "deleted": "角色已删除",
        "deleteError": "删除角色失败"
      }
    },
    "categories": {
      "subtitle": "类别用于分组角色,并定义共享策略 (MFA、会话限制等)。",
      "createButton": "创建类别",
      "requireMfa": "要求 MFA",
      "yes": "是",
      "no": "否",
      "sessionTimeout": "会话超时",
      "sessionTimeoutMinutes": "{{count}} 分钟",
      "maxFailedLogins": "最大失败登录次数",
      "manageDefaults": "管理默认权限",
      "editTitle": "编辑",
      "editAria": "编辑类别",
      "deleteTitle": "删除",
      "deleteAria": "删除类别",
      "empty": "尚未定义任何类别。",
      "delete": {
        "title": "删除类别",
        "description": "确定要删除类别「{{name}}」吗?此操作无法撤销。",
        "confirm": "删除"
      },
      "toast": {
        "deleted": "类别已删除",
        "deleteError": "删除类别失败"
      }
    },
    "confirm": {
      "bulkApply": "将 {{count}} 项更改应用到 {{roleCount}} 个角色?",
      "discardChanges": "放弃未保存的更改?"
    },
    "popover": {
      "grantTitle": "授予权限",
      "denyTitle": "拒绝权限",
      "clearTitle": "清除权限",
      "grantNote": "授予此权限将覆盖所有继承的拒绝设置。",
      "denyNote": "拒绝此权限将覆盖所有继承的授予。",
      "clearNote": "清除后将恢复为继承行为。"
    },
    "toast": {
      "permissionGranted": "权限已授予",
      "permissionDenied": "权限已拒绝",
      "permissionCleared": "权限已清除",
      "bulkApplied": "批量更改已应用",
      "saveError": "保存更改失败"
    }
  },
  "confirm": {
    "restartIntegration": "重启“{{name}}”？加载新的 TLS 材料时，活动连接将短暂中断。",
    "revokeFhirEndpoint": "吊销“{{name}}”？对此端点的出站调用将停止。",
    "rotateSmartSecret": "轮换“{{name}}”的客户端密钥？旧密钥将立即失效。",
    "revokeSmartApp": "吊销“{{name}}”？此应用日后发起的令牌请求将失败。",
    "deactivateThirdPartyApp": "停用“{{name}}”？"
  },
  "toast": {
    "tierCreated": "层级已创建",
    "tierCloned": "层级已克隆",
    "tierDeleted": "层级已删除",
    "tierStatusUpdated": "状态已更新",
    "tierFeaturesUpdated": "功能已更新",
    "tierLimitsUpdated": "限额已更新",
    "tierSaveError": "创建层级失败",
    "tierValidation": "名称和代码为必填项",
    "licenseKeyGenerated": "许可密钥已生成",
    "licenseKeyCopied": "许可密钥已生成并复制到剪贴板",
    "overridesSaved": "覆盖项已保存",
    "pricingConfigSaved": "配置已保存",
    "pricingPriceUpdated": "价格已更新",
    "pricingRuleCreated": "定价规则已创建",
    "addonUpdated": "附加模块已更新",
    "invalidNumber": "请输入有效的数字",
    "csvExported": "已导出 {{filename}}",
    "integrationUpdated": "集成已更新",
    "integrationAdded": "集成已添加",
    "integrationInvalidConfig": "配置无效 — 请检查主机/端口和 TLS 字段",
    "integrationDuplicateName": "已存在同名的集成",
    "integrationSaveFailed": "保存集成失败",
    "smartAppRegistered": "SMART 应用已注册",
    "smartAppRegisterFailed": "注册 SMART 应用失败",
    "smartAppUpdated": "SMART 应用已更新",
    "smartAppUpdateFailed": "更新 SMART 应用失败",
    "fhirEndpointUpdated": "端点已更新",
    "fhirEndpointRegistered": "端点已注册",
    "fhirEndpointInvalidConfig": "配置无效 — 请检查 base URL 和 auth 字段",
    "fhirEndpointDuplicateName": "已存在同名端点",
    "fhirEndpointSaveFailed": "保存端点失败",
    "clientIdCopied": "Client ID 已复制",
    "clientSecretCopied": "Client secret 已复制",
    "statusRefreshed": "状态已刷新",
    "connTestOk": "连接测试成功",
    "connTestFailed": "连接测试失败 - 请检查端点配置",
    "serverRestarted": "服务端已重启 — 新的 TLS 材料已生效",
    "clientReconnected": "客户端已重新连接 — 新的 TLS 材料已生效",
    "notRunning": "未运行 — 请启动服务端/客户端以应用配置",
    "restartFailed": "重启集成失败",
    "metadataOk": "/metadata 正常{{detail}}",
    "metadataFailed": "/metadata 失败：{{error}}",
    "metadataProbeFailed": "探测 /metadata 失败",
    "metadataUnknownError": "未知",
    "fhirRevoked": "FHIR 端点已吊销",
    "fhirRevokeFailed": "吊销端点失败",
    "smartRevoked": "SMART 应用已吊销",
    "smartRevokeFailed": "吊销 SMART 应用失败",
    "secretRotated": "客户端密钥已轮换",
    "rotateSecretFailed": "轮换密钥失败",
    "messageRequeued": "消息已重新排队等待重试",
    "messageRetryFailed": "重试失败",
    "messageSkipped": "消息已跳过——队列将继续推进",
    "messageSkipFailed": "跳过失败",
    "messageAbandoned": "消息已放弃",
    "messageAbandonFailed": "放弃失败",
    "messageResent": "消息已作为新消息重发",
    "messageResendFailed": "重发失败",
    "reasonRequired": "需要填写原因",
    "copiedToClipboard": "已复制到剪贴板",
    "thirdPartyAppCreated": "第三方应用创建成功",
    "thirdPartyAppUpdated": "第三方应用更新成功",
    "thirdPartyAppDeactivated": "第三方应用已停用",
    "thirdPartyAppLaunchUrl": "已生成启动 URL：{{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "添加机构",
      "editTitle": "编辑机构",
      "fields": {
        "name": "名称",
        "code": "代码",
        "type": "类型",
        "address": "地址",
        "city": "城市",
        "stateProvince": "省/州",
        "country": "国家",
        "phone": "电话",
        "timeZone": "时区",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "例如：Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "IANA 时区名称（例如：Asia/Singapore）。用于住院人数、MAR 与报表中的机构本地日期。"
      },
      "options": {
        "otherIana": "其他（IANA）…",
        "useCuratedList": "使用预设列表"
      },
      "errors": {
        "nameMin": "机构名称至少需要 {{min}} 个字符",
        "codeFormat": "代码只能包含大写字母和数字",
        "typeRequired": "机构类型不能为空",
        "countryRequired": "国家不能为空",
        "timeZoneRequired": "时区不能为空",
        "timeZoneInvalidIana": "服务器拒绝该时区。请使用有效的 IANA 名称（例如：Asia/Singapore）。",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "创建",
        "update": "更新"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "机构创建成功",
        "updatedSuccess": "机构更新成功",
        "saveError": "保存机构失败",
        "invalidTimeZone": "请求无效 — 请检查时区是否为有效的 IANA 名称（例如：Asia/Singapore）。"
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "机构管理",
      "subtitle": "机构、科室及（通过此树）物理位置层级的概览。如需查看完整的位置树（建筑 → 楼层 → 单元 → 房间 → 床位），请前往<locationsLink>位置管理</locationsLink>。",
      "columns": {
        "name": "名称",
        "code": "代码",
        "type": "类型",
        "address": "地址",
        "phone": "电话",
        "depts": "科室数",
        "status": "状态",
        "actions": "操作"
      },
      "filter": {
        "search": "搜索机构..."
      },
      "actions": {
        "new": "添加机构",
        "editTitle": "编辑"
      },
      "expand": {
        "expand": "展开机构",
        "collapse": "收起机构"
      },
      "empty": {
        "noMatch": "未找到与搜索匹配的机构。",
        "none": "尚无机构 — 点击「添加机构」开始。"
      },
      "departments": {
        "title": "科室",
        "add": "添加科室",
        "empty": "尚未配置科室",
        "locationsCount": "{{count}} 个位置",
        "editTitle": "编辑科室"
      },
      "locations": {
        "title": "位置",
        "add": "添加",
        "empty": "此科室尚无位置。位置树（建筑 → 楼层 → 单元 → 床位）在<locationsLink>位置管理</locationsLink>中维护。"
      }
    },
    "type": {
      "generalHospital": "综合医院",
      "teachingHospital": "教学医院",
      "specialtyHospital": "专科医院",
      "communityHospital": "社区医院",
      "clinic": "诊所"
    },
    "status": {
      "active": "启用",
      "inactive": "停用"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "新增医疗机构",
      "editTitle": "编辑医疗机构",
      "subtitle": "组织架构的顶层。下辖一个或多个医疗设施。",
      "sections": {
        "identity": "基本信息",
        "primaryContact": "主要联系人",
        "address": "地址"
      },
      "fields": {
        "code": "代码",
        "name": "名称",
        "taxId": "税号",
        "contactName": "姓名",
        "contactEmail": "电子邮箱",
        "contactPhone": "电话",
        "addressLine1": "地址第一行",
        "addressLine2": "地址第二行",
        "city": "城市",
        "stateProvince": "省/州",
        "postalCode": "邮政编码",
        "country": "国家/地区",
        "active": "启用 — 取消勾选可停用该机构。"
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "代码创建后不可修改。"
      },
      "errors": {
        "codeRequired": "请输入代码",
        "nameRequired": "请输入名称"
      },
      "submit": {
        "create": "创建医疗机构",
        "update": "保存更改"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "医疗机构创建成功",
        "updatedSuccess": "医疗机构更新成功",
        "saveError": "保存医疗机构失败",
        "codeConflict": "该机构代码已存在",
        "invalidData": "医疗机构数据无效"
      }
    },
    "list": {
      "title": "医疗机构",
      "subtitle": "组织树的顶层 — 拥有一个或多个院区的企业 / 医疗机构母级。初始设置后很少更改。",
      "columns": {
        "name": "名称",
        "code": "代码",
        "contact": "联系方式",
        "location": "位置",
        "facilities": "院区数",
        "status": "状态",
        "actions": "操作"
      },
      "filter": {
        "search": "按名称或代码搜索..."
      },
      "actions": {
        "new": "新增医疗机构",
        "editTitle": "编辑"
      },
      "status": {
        "active": "启用",
        "inactive": "停用"
      },
      "empty": {
        "noMatch": "未找到与搜索匹配的医疗机构。",
        "none": "尚无医疗机构 — 点击「新增医疗机构」开始。"
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "添加位置",
      "editTitle": "编辑位置",
      "subtitle": "物理位置——楼栋、楼层、单元、房间或床位。兼容 FHIR R4 Location。通过上级位置进行嵌套以构建层级树。",
      "sections": {
        "hierarchy": "层级",
        "identity": "标识",
        "classification": "分类",
        "physicalAttributes": "物理属性"
      },
      "fields": {
        "facility": "机构",
        "parentLocation": "上级位置",
        "department": "科室（可选）",
        "code": "编码",
        "abbreviation": "简称",
        "name": "名称",
        "physicalType": "物理类型（FHIR）",
        "clinicalType": "临床类型",
        "status": "状态（FHIR）",
        "operationalStatus": "运行状态（HL7 0116）",
        "building": "楼栋",
        "floor": "楼层",
        "wing": "区翼",
        "roomNumber": "房间号",
        "bedIdentifier": "床位标识",
        "capacity": "容量",
        "active": "启用（旧标记）"
      },
      "placeholders": {
        "facility": "选择机构…",
        "parentNone": "无（顶级）",
        "departmentNone": "无",
        "code": "4W-12-A",
        "name": "4W-12 床位 A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "FHIR LocationPhysicalType 值集。",
        "clinicalType": "旧字段；service_type 上线后移除。"
      },
      "physicalAttributes": {
        "show": "展开 ▾",
        "hide": "收起 ▴"
      },
      "errors": {
        "facilityRequired": "请选择机构",
        "codeRequired": "请输入编码",
        "nameRequired": "请输入名称"
      },
      "submit": {
        "create": "创建位置",
        "update": "保存更改"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "位置创建成功",
        "updatedSuccess": "位置更新成功",
        "saveError": "保存位置失败",
        "codeConflict": "该位置编码已存在",
        "invalidData": "位置数据无效"
      }
    },
    "list": {
      "title": "位置层级",
      "subtitle": "物理树状结构：楼宇 → 楼层 → 单元 → 房间 → 床位。与 FHIR LocationPhysicalType 对齐。点击床位状态标记可循环切换占用情况。机构和科室在 <facilitiesLink>机构</facilitiesLink> 中管理。",
      "filter": {
        "search": "按名称或编码搜索...",
        "allFacilities": "全部机构"
      },
      "actions": {
        "new": "新增位置",
        "addChildTitle": "新增子级",
        "editTitle": "编辑"
      },
      "expand": {
        "expand": "展开位置",
        "collapse": "收起位置"
      },
      "bed": {
        "toggleTitle": "点击切换为 {{next}}"
      },
      "empty": {
        "noMatch": "没有匹配该搜索的位置。",
        "none": "此机构暂无位置。"
      },
      "toast": {
        "bedStatusUpdated": "床位状态已更新",
        "bedStatusError": "更新床位状态失败"
      }
    },
    "type": {
      "si": "院区",
      "bu": "楼宇",
      "wi": "翼楼",
      "wa": "病房",
      "lvl": "楼层",
      "co": "走廊",
      "ro": "房间",
      "bd": "床位",
      "ve": "虚拟",
      "ho": "住所",
      "ca": "柜",
      "rd": "道路",
      "area": "区域",
      "jdn": "辖区"
    },
    "clinicalType": {
      "examRoom": "诊室",
      "inpatientBed": "住院床位",
      "procedureRoom": "操作室",
      "icu": "ICU",
      "ed": "急诊",
      "or": "手术室",
      "virtual": "虚拟"
    },
    "status": {
      "active": "启用",
      "suspended": "暂停",
      "inactive": "停用",
      "op": {
        "O": "已占用",
        "U": "空闲",
        "H": "保洁中",
        "K": "已污染",
        "I": "隔离",
        "C": "关闭"
      }
    },
    "capability": {
      "isolation": "可隔离",
      "negativePressure": "负压",
      "bariatric": "可减重（肥胖症）",
      "telemetry": "可遥测",
      "icu": "ICU 级别"
    }
  },
  "department": {
    "form": {
      "addTitle": "新增科室",
      "editTitle": "编辑科室",
      "subtitle": "院区下的组织单元。可以嵌套（例如：心血管科 → 电生理实验室），通过上级科室设置。",
      "sections": {
        "department": "科室"
      },
      "fields": {
        "facility": "院区",
        "code": "代码",
        "abbreviation": "缩写",
        "name": "名称",
        "type": "类型",
        "parentDepartment": "上级科室",
        "costCenterCode": "成本中心代码",
        "revenueDepartmentCode": "收入科室代码",
        "active": "启用 — 取消勾选可停用该科室。"
      },
      "placeholders": {
        "facility": "选择院区…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "心血管科",
        "parentNone": "无（顶层）",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "请选择院区",
        "codeRequired": "请输入代码",
        "nameRequired": "请输入名称"
      },
      "submit": {
        "create": "创建科室",
        "update": "保存更改"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "科室创建成功",
        "updatedSuccess": "科室更新成功",
        "saveError": "保存科室失败",
        "codeConflict": "该科室代码已存在",
        "invalidData": "科室数据无效"
      }
    },
    "serviceType": {
      "clinical": "临床",
      "administrative": "行政",
      "support": "辅助"
    },
    "status": {
      "active": "启用",
      "inactive": "停用"
    }
  },
  "provider": {
    "form": {
      "addTitle": "添加医务人员",
      "editTitle": "编辑医务人员",
      "fields": {
        "fullName": "姓名",
        "npi": "NPI",
        "providerType": "医疗人员类型",
        "credentials": "资质证书",
        "specialty": "专科",
        "email": "电子邮箱",
        "phone": "电话",
        "facilityAssignments": "机构分配",
        "status": "状态",
        "primaryFacility": "主要机构",
        "loginAccount": "登录账户"
      },
      "placeholders": {
        "specialty": "请选择专科…",
        "credentials": "例如：MD、FACC",
        "providerType": "选择医疗人员类型",
        "noLoginAccount": "无登录账户"
      },
      "submit": {
        "create": "创建",
        "update": "更新"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "已创建医务人员",
        "updatedSuccess": "已更新医务人员",
        "saveError": "保存医务人员失败"
      },
      "hints": {
        "loginAccount": "将该临床人员与其登录账户关联。未关联时，会签、药师核对与危急值确认都将拒绝该用户。"
      }
    },
    "list": {
      "title": "医师管理",
      "subtitle": "管理医师、资质证书和机构分配",
      "columns": {
        "name": "姓名",
        "npi": "NPI",
        "specialty": "专科",
        "credentials": "资质",
        "facilities": "机构",
        "status": "状态",
        "actions": "操作"
      },
      "filter": {
        "search": "按姓名、NPI、专科搜索…",
        "allSpecialties": "所有专科",
        "allFacilities": "所有机构",
        "allStatus": "所有状态"
      },
      "actions": {
        "new": "添加医师",
        "editTitle": "编辑医师",
        "scheduleTitle": "排班模板",
        "viewCredentials": "查看资质"
      },
      "credentials": {
        "licenseLabel": "执照",
        "none": "无在档资质"
      },
      "empty": "未找到医师",
      "pagination": {
        "summary": "第 {{from}}-{{to}} 条，共 {{total}} 条",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "上一页",
        "next": "下一页"
      },
      "toast": {
        "schedulePlaceholder": "排班模板链接（占位）"
      },
      "noLogin": "无登录",
      "noLoginHint": "该医务人员未关联登录账户，无法进行会签、核对或确认。"
    },
    "specialty": {
      "internalMedicine": "内科",
      "cardiology": "心血管内科",
      "emergencyMedicine": "急诊医学科",
      "pediatrics": "儿科",
      "pathology": "病理科",
      "obstetricsGynecology": "妇产科",
      "surgery": "外科",
      "orthopedics": "骨科",
      "neurology": "神经内科",
      "psychiatry": "精神科",
      "radiology": "放射科",
      "anesthesiology": "麻醉科",
      "oncology": "肿瘤科",
      "dermatology": "皮肤科",
      "ophthalmology": "眼科"
    },
    "status": {
      "active": "在职",
      "inactive": "停用",
      "onLeave": "休假中"
    },
    "providerType": {
      "physician": "医师",
      "nurse": "护士",
      "nursePractitioner": "执业护士",
      "physicianAssistant": "医师助理",
      "pharmacist": "药剂师",
      "therapist": "治疗师",
      "technician": "技师",
      "other": "其他",
      "midwife": "助产士",
      "dentist": "牙医",
      "pharmacyTechnician": "药剂技师",
      "careAssistant": "护理员",
      "dietitian": "营养师",
      "socialWorker": "社会工作者",
      "traditionalMedicine": "中医师"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "添加服务线",
      "editTitle": "编辑服务线",
      "subtitle": "高级别临床分组(心血管、肿瘤学),作为具体临床服务的上级。",
      "sections": {
        "serviceLine": "服务线"
      },
      "fields": {
        "healthSystem": "医疗系统",
        "code": "代码",
        "name": "名称",
        "description": "描述",
        "active": "启用 — 取消勾选以软停用。"
      },
      "placeholders": {
        "healthSystem": "选择医疗系统…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "简短描述 — 范围、疾病重点等。"
      },
      "errors": {
        "healthSystemRequired": "医疗系统为必填项",
        "codeRequired": "代码为必填项",
        "nameRequired": "名称为必填项"
      },
      "submit": {
        "create": "创建服务线",
        "update": "保存更改"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "已创建服务线",
        "updatedSuccess": "已更新服务线",
        "saveError": "保存服务线失败",
        "codeConflict": "服务线代码已存在",
        "invalidData": "服务线数据无效"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "添加临床服务",
      "editTitle": "编辑临床服务",
      "subtitle": "具体的临床服务(心血管内科、EP 实验室)。可选择归入服务线之下,并附加 NUCC 专科代码,用于计费和目录输出。",
      "sections": {
        "clinicalService": "临床服务",
        "specialtyBilling": "专科 + 计费"
      },
      "fields": {
        "code": "代码",
        "name": "名称",
        "serviceLine": "服务线",
        "description": "描述",
        "specialtyCode": "NUCC 专科代码",
        "specialtyDescription": "专科描述",
        "revenueDepartmentCode": "收入部门代码",
        "active": "启用"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— 无 —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "NUCC 分类 — 驱动医务人员目录与理赔单据呈现。"
      },
      "errors": {
        "codeRequired": "代码为必填项",
        "nameRequired": "名称为必填项"
      },
      "submit": {
        "create": "创建临床服务",
        "update": "保存更改"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "已创建临床服务",
        "updatedSuccess": "已更新临床服务",
        "saveError": "保存临床服务失败",
        "codeConflict": "临床服务代码已存在",
        "invalidData": "临床服务数据无效"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "服务 ↔ 地点分配",
    "subtitle": "哪些临床服务在哪些实际地点开展,可选日/时段窗口与容量。排班据此生成可预约时段。仅软删除 — 结束分配会保留历史以供报表使用。",
    "header": {
      "newAssignment": "新建分配",
      "toggleCancel": "取消"
    },
    "form": {
      "title": "新建分配",
      "fields": {
        "service": "临床服务",
        "location": "地点",
        "dayOfWeekPattern": "星期模式",
        "startTime": "开始时间",
        "endTime": "结束时间",
        "capacity": "容量 %",
        "notes": "备注",
        "isPrimary": "作为该服务的主要地点"
      },
      "placeholders": {
        "service": "选择服务…",
        "location": "选择地点…",
        "dayOfWeekPattern": "1,3,5(周一/周三/周五)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "逗号分隔的 ISO 星期;留空表示每天。"
      },
      "errors": {
        "serviceLocationRequired": "服务和地点为必填项"
      },
      "create": "创建",
      "cancel": "取消"
    },
    "filter": {
      "allFacilities": "全部机构",
      "allServices": "全部服务",
      "allLocations": "全部地点",
      "allStatuses": "全部状态",
      "searchService": "搜索服务…",
      "searchLocation": "搜索地点…",
      "facility": "机构",
      "serviceLine": "服务线"
    },
    "columns": {
      "service": "服务",
      "location": "地点",
      "facility": "机构",
      "when": "时间",
      "capacity": "容量",
      "effective": "生效",
      "status": "状态",
      "actions": "操作"
    },
    "status": {
      "active": "启用",
      "planned": "计划中",
      "suspended": "已暂停",
      "ended": "已结束"
    },
    "dow": {
      "everyDay": "每天",
      "monFri": "周一至周五",
      "short": {
        "1": "周一",
        "2": "周二",
        "3": "周三",
        "4": "周四",
        "5": "周五",
        "6": "周六",
        "7": "周日"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "主要地点",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "设为主要",
      "unsetPrimary": "取消主要",
      "endAssignment": "结束分配"
    },
    "bulkEdit": {
      "title": "批量编辑",
      "applyTo": "应用到所选",
      "selectedServices": "{{count}} 个服务",
      "selectedLocations": "{{count}} 个地点",
      "save": "保存更改",
      "cancel": "取消"
    },
    "confirm": {
      "endTitle": "结束分配?",
      "endDescription": "{{service}} → {{location}}。结束会保留历史,但会将该配对从有效排班中移除。",
      "endConfirm": "结束分配",
      "removeService": "将 {{service}} 从 {{location}} 移除?",
      "makePrimary": "将 {{location}} 设为 {{service}} 的主要地点?"
    },
    "toast": {
      "created": "已创建分配",
      "createError": "创建分配失败",
      "ended": "已结束分配",
      "endError": "结束分配失败",
      "primaryError": "切换主要地点失败",
      "updated": "已更新分配"
    },
    "empty": "没有符合这些筛选条件的分配。点击“新建分配”添加一个。"
  },
  "integration": {
    "list": {
      "title": "集成管理",
      "subtitle": "HL7、FHIR 及第三方系统集成",
      "refresh": "刷新",
      "addEndpoint": "添加端点",
      "searchPlaceholder": "搜索集成…",
      "tabs": {
        "endpoints": "端点",
        "messageLog": "消息日志",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "端点总数",
        "connected": "已连接",
        "errors": "错误",
        "totalMessages": "消息总数"
      }
    },
    "columns": {
      "status": "状态",
      "name": "名称",
      "type": "类型",
      "direction": "方向",
      "url": "URL",
      "tls": "TLS",
      "auth": "认证",
      "lastMessage": "最近消息",
      "messages": "消息数",
      "errors": "错误数",
      "backlog": "积压",
      "health": "健康状况",
      "actions": "操作",
      "backlogTitle": "待发送出站消息 + 最早待处理消息的等待时长",
      "healthTitle": "健康状态 — 如果队列因某条失败消息而阻塞则显示红色"
    },
    "badge": {
      "tlsCerts": "证书：{{cert}}，密钥：{{key}}，CA：{{ca}}",
      "yes": "是",
      "no": "否",
      "basicTitle": "basic（{{username}}）",
      "bearerStored": "已存储 Bearer 令牌",
      "bearerNoToken": "bearer（未设置令牌）",
      "mtlsCert": "mTLS 客户端证书",
      "awaitingAck": "{{n}} 条等待 ACK",
      "oldest": "最早 {{age}}",
      "never": "从未",
      "blocked": "已阻塞",
      "waiting": "等待中",
      "ok": "正常",
      "blockedTitle": "一条失败消息正在阻塞此集成的队列。点击打开已过滤的日志。",
      "waitingTitle": "正在等待合作方返回增强模式应用 ACK 的消息。点击打开已过滤的日志。",
      "okTitle": "一切正常 — 点击打开此集成的消息日志。",
      "receives": "接收"
    },
    "action": {
      "testConnection": "测试连接",
      "restartTls": "重启 — 应用刚轮换的 TLS",
      "investigate": "吞吐量、延迟与近期失败",
      "edit": "编辑"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "最近 50 条消息",
      "columns": {
        "time": "时间",
        "id": "ID",
        "direction": "方向",
        "type": "类型",
        "source": "来源",
        "summary": "摘要",
        "status": "状态"
      },
      "dir": {
        "in": "入",
        "out": "出"
      }
    },
    "fhir": {
      "serverStatusHeader": "FHIR R4 服务器状态",
      "serverOnline": "服务器在线",
      "supportedResources": "支持的资源",
      "version": "版本",
      "externalHeader": "外部 FHIR 端点",
      "registerEndpoint": "注册端点",
      "columns": {
        "name": "名称",
        "baseUrl": "基础 URL",
        "auth": "认证",
        "status": "状态",
        "lastChecked": "最近检查",
        "actions": "操作"
      },
      "emptyEndpoints": "尚未注册任何外部 FHIR 端点。",
      "revoked": "已吊销",
      "statusOk": "正常",
      "statusError": "错误",
      "testMetadata": "测试 /metadata",
      "edit": "编辑",
      "revoke": "吊销"
    },
    "smart": {
      "header": "已注册的 SMART 应用",
      "registerApp": "注册应用",
      "columns": {
        "appName": "应用名称",
        "clientId": "Client ID",
        "scopes": "权限范围",
        "status": "状态",
        "lastModified": "最近修改",
        "actions": "操作"
      },
      "emptyApps": "尚未注册任何 SMART 应用。",
      "edit": "编辑",
      "rotateSecret": "轮换客户端密钥",
      "revoke": "吊销"
    },
    "secretModal": {
      "title": "请立即保存此 client secret",
      "body": "此密钥仅显示一次。若丢失，请轮换密钥以重新签发。",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "复制 Client ID",
      "copyClientSecret": "复制 Client Secret",
      "saved": "我已保存"
    },
    "drawer": {
      "header": "集成 #{{id}}",
      "refresh": "刷新",
      "close": "关闭",
      "queueBlocked": "队列已阻塞",
      "queueBlockedBody": "一条失败的消息正阻止此集成发送。其后的消息将一直等待，直到操作员处理。",
      "investigate": "排查",
      "tiles": {
        "backlog": "积压",
        "success24h": "24h 成功率",
        "avgLatency24h": "24h 平均延迟",
        "awaitingAck": "等待 app-ACK"
      },
      "charts": {
        "throughput": "吞吐量（24h）",
        "throughputSub": "按小时分桶。堆叠：出站已完成 + 失败；入站在次坐标轴上。",
        "successRate": "成功率（24h）",
        "successRateSub": "按桶统计：已完成 /（已完成 + 失败）。空缺为空闲桶。",
        "ackLatency": "ACK 延迟（24h）",
        "ackLatencySub": "发送至收到 ACK 之间的时间。avg 为实线，p95 为虚线。"
      },
      "series": {
        "outCompleted": "出站 · 已完成",
        "outFailed": "出站 · 失败",
        "inReceived": "入站 · 已接收",
        "successPct": "成功率 %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "近期失败",
      "viewAll": "查看全部 →",
      "noFailures": "近期窗口内没有失败消息。🎉"
    }
  },
  "integrationStatus": {
    "connected": "已连接",
    "disconnected": "已断开",
    "error": "错误"
  },
  "integrationDirection": {
    "server": "服务端",
    "client": "客户端"
  },
  "messageStatus": {
    "sent": "已发送",
    "received": "已接收",
    "error": "错误",
    "acknowledged": "已确认"
  },
  "smartAppStatus": {
    "active": "启用",
    "revoked": "已吊销"
  },
  "interfaceMessageStatus": {
    "pending": "待处理",
    "processing": "处理中",
    "completed": "已完成",
    "received": "已接收",
    "processed": "已处理",
    "failed": "失败",
    "error": "错误",
    "rejected": "已拒绝",
    "deadLetter": "死信",
    "skipped": "已跳过",
    "awaitingAppAck": "等待应用 ACK"
  },
  "interfaceDirection": {
    "in": "入站",
    "out": "出站"
  },
  "attemptOutcome": {
    "sent": "已发送",
    "appNak": "应用 NAK",
    "timeout": "超时",
    "networkError": "网络错误"
  },
  "fhirEndpoint": {
    "titleEdit": "编辑 FHIR 端点",
    "titleRegister": "注册 FHIR 端点",
    "subtitle": "网关出站通信的外部 FHIR R4 合作伙伴。集成列表上的 Test Connection 按钮会使用已配置的 auth + TLS 探测 <code>/metadata</code>。",
    "back": "返回",
    "cancel": "取消",
    "storedBlank": "已存储 — 留空以保留",
    "save": {
      "changes": "保存更改",
      "register": "注册端点"
    },
    "section": {
      "basics": "基本信息",
      "auth": "认证",
      "tls": "TLS"
    },
    "fields": {
      "name": "名称",
      "baseUrl": "Base URL",
      "description": "说明",
      "active": "启用 — 取消勾选可软撤销。",
      "method": "方式",
      "username": "用户名",
      "password": "密码",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "需要 https://（开发环境接受 http://localhost）。Test 期间会自动追加末尾的 /metadata。",
      "oauth2": "OAuth2 令牌获取已在管理端接入；运行时获取器将在后续版本中提供。目前请填写值并运行 Test 以验证其余配置。",
      "tls": "粘贴根 CA 以固定合作伙伴的服务器证书，或粘贴 client cert + key 用于 mTLS。对于知名 CA，仅 CA 即可与系统根存储配合使用。"
    },
    "option": {
      "method": {
        "none": "无",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — 对大多数合作伙伴可选",
      "clientCertRequired": "Client certificate (PEM) — 必填",
      "clientCertMtls": "Client certificate (PEM) — 用于 mTLS",
      "clientKeyRequired": "Client private key (PEM) — 必填",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "名称为必填项",
      "baseUrlRequired": "Base URL 为必填项",
      "baseUrlInvalid": "基础 URL 必须是有效的 http(s) 地址",
      "basicUsername": "Basic auth 需要用户名",
      "basicPassword": "Basic auth 需要密码",
      "bearerToken": "Bearer auth 需要 token",
      "clientCertKey": "Client-certificate auth 需要 cert + key"
    }
  },
  "smartApp": {
    "titleEdit": "编辑 SMART 应用",
    "titleRegister": "注册 SMART 应用",
    "subtitle": "SMART on FHIR 客户端注册。Client ID 由系统自动生成；client secret 在创建或轮换后仅显示一次。",
    "back": "返回",
    "cancel": "取消",
    "save": "保存更改",
    "register": "注册",
    "fields": {
      "appName": "应用名称",
      "redirectUris": "重定向 URI",
      "scopes": "权限范围",
      "launchUrl": "启动 URL",
      "logoUrl": "Logo URL",
      "active": "启用 — 取消勾选可软撤销此应用。"
    },
    "placeholder": {
      "appName": "我的 EHR 启动器"
    },
    "helper": {
      "redirectUris": "每行一个 URI。需使用 https://（开发环境也接受 http://localhost）。"
    },
    "secretModal": {
      "title": "请立即保存此 client secret",
      "body": "此密钥仅显示一次。若丢失，请轮换密钥以重新签发。",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "复制 Client ID",
      "copyClientSecret": "复制 Client Secret",
      "saved": "我已保存"
    },
    "validation": {
      "nameRequired": "名称为必填项",
      "redirectUriRequired": "至少需要一个重定向 URI",
      "scopeRequired": "至少需要一个权限范围"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "接口消息日志",
      "subtitle": "所有活动集成的入站与出站 HL7 消息。",
      "refresh": "刷新",
      "loading": "正在加载消息…",
      "empty": "没有符合当前筛选条件的消息。",
      "pagination": "{{total}} 条消息 • 第 {{page}} / {{pages}} 页",
      "prev": "上一页",
      "next": "下一页",
      "archived": "(归档)"
    },
    "relative": {
      "secondsAgo": "{{n}} 秒前",
      "minutesAgo": "{{n}} 分钟前",
      "hoursAgo": "{{n}} 小时前"
    },
    "filter": {
      "header": "筛选",
      "direction": "方向",
      "status": "状态",
      "messageType": "消息类型",
      "msh10": "MSH-10 包含",
      "integrationId": "集成 ID",
      "includeArchive": "包含归档",
      "clear": "清除筛选",
      "any": "任意",
      "messageTypePlaceholder": "例如 ADT^A01",
      "controlIdPlaceholder": "控制 ID"
    },
    "columns": {
      "id": "ID",
      "dir": "方向",
      "integ": "集成",
      "type": "类型",
      "msh10": "MSH-10",
      "status": "状态",
      "ack": "ACK",
      "attempts": "尝试",
      "when": "时间"
    },
    "detail": {
      "eyebrow": "{{direction}}消息",
      "close": "关闭",
      "loading": "正在加载…",
      "tabs": {
        "overview": "概览",
        "rawHl7": "原始 HL7",
        "attempts": "尝试"
      },
      "operatorActions": "操作员操作",
      "retry": "重试",
      "skip": "跳过",
      "abandon": "放弃",
      "resendAsNew": "作为新消息重发",
      "skipReason": "跳过原因",
      "abandonReason": "放弃原因",
      "actionsHelper": "操作会连同您的用户 ID 与原因一并审计。跳过和放弃需要填写原因。",
      "overview": {
        "direction": "方向",
        "integration": "集成",
        "type": "类型",
        "msh10": "MSH-10",
        "status": "状态",
        "ackCode": "ACK 代码",
        "attempts": "尝试",
        "created": "创建时间",
        "ackReceived": "收到 ACK",
        "nextRetry": "下次重试",
        "ackText": "ACK 文本",
        "lastError": "最后错误",
        "sourceEventId": "源事件 ID"
      },
      "rawViewer": {
        "permissionDenied": "解密后的原始 HL7 需要 <code>INTERFACE_OPERATE</code> 权限。",
        "notAvailable": "此消息没有可用的原始负载。",
        "bytes": "{{bytes}} 字节",
        "copy": "复制"
      },
      "attempts": {
        "inboundInfo": "尝试历史仅针对出站消息进行跟踪。入站消息按 MSH-10 处理一次；重传将返回缓存的 ACK，不会产生新的尝试。",
        "totalAttempts": "尝试总数",
        "nextAt": "（下次于 {{time}}）",
        "refresh": "刷新",
        "loading": "正在加载尝试…",
        "error": "加载尝试失败。",
        "empty": "尚未记录任何尝试。工作进程每次发送写入一行；首次认领后此列表将填充。",
        "columns": {
          "when": "时间",
          "outcome": "结果",
          "ack": "ACK",
          "duration": "持续时间",
          "detail": "详情"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "第三方应用程序",
      "subtitle": "配置可从 VynaEMR 携带患者上下文启动的外部应用程序",
      "addApp": "添加应用程序",
      "searchPlaceholder": "按名称、代码或类别搜索应用...",
      "emptyTitle": "未配置任何应用程序",
      "emptyBody": "添加外部应用程序，例如 PACS 查看器、检验门户或药房系统。",
      "columns": {
        "application": "应用程序",
        "category": "类别",
        "url": "URL",
        "security": "安全",
        "display": "显示",
        "status": "状态",
        "actions": "操作"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "JWT 已签名",
      "hmac": "HMAC",
      "hmacSigned": "HMAC 已签名",
      "none": "无",
      "chart": "图表",
      "sidebar": "侧边栏",
      "active": "启用",
      "inactive": "停用"
    },
    "action": {
      "testLaunch": "测试启动",
      "edit": "编辑",
      "deactivate": "停用"
    },
    "form": {
      "titleEdit": "编辑应用程序",
      "titleNew": "新建应用程序",
      "fields": {
        "appCode": "应用代码",
        "appName": "应用名称",
        "category": "类别",
        "baseUrl": "基础 URL",
        "launchMethod": "启动方式",
        "paramMappings": "参数映射",
        "enableJwt": "启用 JWT 令牌签名",
        "sharedSecret": "共享密钥（JWT 签名密钥）",
        "enableHmac": "启用 URL 签名（HMAC）",
        "hmacKey": "HMAC 密钥",
        "requiredPermission": "所需权限",
        "displayOrder": "显示顺序",
        "showInChart": "在图表中显示",
        "showInSidebar": "在侧边栏中显示"
      },
      "placeholder": {
        "appCode": "例如 pacs_viewer",
        "appName": "例如 PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "URL 参数名",
        "unchanged": "（保持不变）",
        "sharedSecret": "输入共享密钥",
        "hmacKey": "输入 HMAC 密钥",
        "requiredPermission": "例如 RESULT_VIEW（留空 = 任何用户）"
      },
      "addParameter": "添加参数",
      "cancel": "取消",
      "submitUpdate": "更新应用程序",
      "submitCreate": "创建应用程序"
    },
    "paramSource": {
      "patientMrn": "患者 MRN",
      "patientName": "患者姓名",
      "patientDob": "患者 DOB",
      "encounterId": "就诊 ID",
      "encounterNumber": "就诊编号",
      "orderNumber": "医嘱编号",
      "userName": "当前用户姓名",
      "userId": "当前用户 ID",
      "timestamp": "当前时间戳"
    },
    "launch": "启动 {{name}}"
  },
  "integrationForm": {
    "titleEdit": "编辑集成",
    "titleAdd": "添加集成",
    "subtitle": "由 VynaHL7 支持的 MLLP 与 HL7-over-HTTP 接口。证书材料存储在集成记录上；轮换将在下次重启服务器或客户端时生效。",
    "back": "返回",
    "cancel": "取消",
    "saveChanges": "保存更改",
    "addIntegration": "添加集成",
    "storedBlank": "已存储 — 留空以保留",
    "selectSibling": "— 选择一个同级集成 —",
    "section": {
      "basics": "基本信息",
      "connection": "连接",
      "tls": "TLS / mTLS",
      "auth": "身份验证",
      "ackDelivery": "确认与投递",
      "outboundRouting": "出站路由",
      "inboundTrust": "入站信任"
    },
    "fields": {
      "name": "名称",
      "type": "类型",
      "direction": "方向",
      "description": "描述",
      "active": "启用 — 取消勾选可软停用此接口。",
      "host": "主机",
      "port": "端口",
      "enableTls": "启用 TLS — 使用",
      "serverCert": "服务器证书（PEM）",
      "clientCert": "客户端证书（PEM）— mTLS 可选",
      "serverKey": "服务器私钥（PEM）",
      "clientKey": "客户端私钥（PEM）",
      "serverCa": "客户端 CA 信任库（PEM）— 用于 mTLS",
      "clientCa": "服务器 CA 信任库（PEM）— 可选，回退到系统根证书",
      "method": "方法",
      "username": "用户名",
      "password": "密码",
      "bearerToken": "Bearer 令牌",
      "inboundAck": "入站 ACK 策略",
      "outboundAck": "出站 ACK 策略",
      "processingTimeout": "处理超时（毫秒）",
      "pendingAckTtl": "待处理 ACK TTL（秒）",
      "networkRetry": "网络重试上限",
      "appNakRetry": "应用 NAK 重试上限",
      "reverseIntegration": "反向通道集成",
      "outboundTypes": "接收的消息类型",
      "outboundEvents": "事件级订阅",
      "receivingApplication": "接收应用 (MSH-5)",
      "receivingFacility": "接收机构 (MSH-6)",
      "inboundTrustProfile": "此合作方可以"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "关于此接口的简短说明 — 负责人、用途、消息类型等。",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "绑定地址。使用 0.0.0.0 可监听所有接口。",
      "hostClient": "此客户端应连接的远程主机。",
      "tlsHandshake": "进行握手。",
      "authClientCert": "客户端证书/密钥来自上方的 TLS 部分。",
      "authNone": "不附加 HTTP 认证头。",
      "authRs7": "{{call}} 会将其接入每个出站请求。",
      "ackDefaults": "控制网关如何 ACK 入站 HL7 消息，以及如何解释出站发送的响应 ACK。默认值",
      "ackDefaultsTail": "与 0.19.0 之前的行为一致 — 可按合作方需要更改。",
      "processingTimeout": "同步应用 ACK 内联处理的上限。超时 → AE + 后台队列重试。",
      "pendingAckTtl": "增强模式应用 ACK 等待时间，超过后由清扫器超时处理。",
      "networkRetry": "队列阻塞前的传输错误重试次数。",
      "appNakRetry": "AE/AR/CE/CR 的重试次数 — 通常为 2–3 次，因为同一负载很少在重试后成功。",
      "reverse": "增强模式通过指向合作方反向端点的同级集成投递真正的应用 ACK。请先将同级创建为单独的集成记录，然后在此处链接。",
      "outboundRouting": "此合作方接收的内容。未选择任何类型即表示此接口不是出站目标，不会向其发送任何消息。",
      "outboundEvents": "可选，以逗号分隔。比整个消息类型更精细 —— 适用于只需要特定事件的合作方。",
      "receivingDefaults": "MSH-5 与 MSH-6 用于标识发送到此处的每条消息的接收方。留空则使用接口名称。",
      "inboundTrust": "此合作方可以对患者身份作出何种断言。身份验证说明谁在连接；此设置说明允许他们告诉我们什么。除非该对端确实是登记主控系统，否则请保留部署默认值。"
    },
    "option": {
      "type": {
        "mllp": "MLLP（基于 TCP 的 HL7 v2）",
        "hoh": "HoH（基于 HTTPS 的 HL7）",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "客户端（出站）",
        "server": "服务器（入站）"
      },
      "method": {
        "none": "无",
        "basic": "HTTP Basic",
        "bearer": "Bearer 令牌",
        "clientCert": "客户端证书（mTLS）"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "立即返回 AA（当前默认）",
        "honorMsh16": "按消息读取 MSH-15/16",
        "forceSync": "内联处理，按结果返回 AA/AE/AR",
        "forceEnhanced": "立即返回 CA + 通过反向通道返回应用 ACK"
      },
      "outbound": {
        "fireAndForget": "发送后不等待（当前默认）",
        "expectSync": "设置 MSH-16=AL，在 AE/AR 时重试",
        "expectEnhanced": "等待 CA + 后续的应用 ACK"
      }
    },
    "validation": {
      "nameRequired": "名称为必填项",
      "hostRequired": "主机为必填项",
      "mllpPort": "MLLP 集成需要一个端口",
      "portNumber": "端口必须为数字",
      "tlsServerCertKey": "TLS 服务器同时需要证书和密钥",
      "basicUsername": "Basic 认证需要用户名",
      "basicPassword": "Basic 认证需要密码",
      "bearerToken": "Bearer 认证需要令牌",
      "enhancedReverse": "增强 ACK 模式需要一个反向集成 — 请在下方选择。",
      "outboundEvent": "“{{value}}”不是本系统发送的消息 —— 请使用 ADT 这样的类型，或 ADT^A01 这样的事件。"
    },
    "trust": {
      "useDeploymentDefault": "使用部署默认值",
      "observer": "观察者 — 从不创建或修改患者",
      "demographics": "人口学信息 — 可更正我们已有的患者信息，包括死亡通知；从不创建",
      "registration": "登记 — 还可创建患者并合并病历"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "影像",
    "laboratory": "检验",
    "pharmacy": "药房",
    "specialty": "专科",
    "portal": "门户",
    "billing": "计费",
    "other": "其他"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "重定向",
    "popup": "弹出窗口",
    "iframe": "iframe",
    "newTab": "新标签页"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "编辑 CDS 规则",
      "titleCreate": "创建 CDS 规则",
      "ruleName": "规则名称",
      "ruleType": "规则类型",
      "selectPlaceholder": "请选择…",
      "severity": "严重程度",
      "triggerEvent": "触发事件",
      "actionType": "动作类型",
      "description": "描述",
      "active": "启用",
      "cancel": "取消",
      "submitUpdate": "更新规则",
      "submitCreate": "创建规则",
      "createdOk": "规则创建成功",
      "createFailed": "创建规则失败",
      "updatedOk": "规则更新成功",
      "updateFailed": "更新规则失败",
      "validation": {
        "nameRequired": "规则名称为必填项",
        "typeRequired": "规则类型为必填项",
        "descriptionRequired": "描述为必填项",
        "triggerRequired": "触发事件为必填项",
        "actionRequired": "动作类型为必填项"
      }
    },
    "list": {
      "title": "CDS 规则",
      "subtitle": "管理临床决策支持规则",
      "addRule": "添加规则",
      "loading": "正在加载 CDS 规则…",
      "loadError": "加载 CDS 规则失败。",
      "empty": "尚未配置 CDS 规则。",
      "columns": {
        "ruleName": "规则名称",
        "type": "类型",
        "severity": "严重程度",
        "description": "描述",
        "status": "状态",
        "actions": "操作"
      },
      "toggleActive": "点击以停用",
      "toggleInactive": "点击以启用",
      "active": "启用",
      "inactive": "停用",
      "editRule": "编辑规则",
      "statusUpdated": "规则状态已更新",
      "statusUpdateFailed": "更新规则状态失败"
    }
  },
  "cdsSeverity": {
    "info": "信息",
    "warning": "警告",
    "critical": "严重"
  },
  "cdsTriggerEvent": {
    "orderSign": "医嘱签署",
    "orderSelect": "医嘱选择",
    "patientView": "查看患者",
    "medicationPrescribe": "药物开立",
    "resultReceived": "结果接收",
    "patientAdmit": "患者入院"
  },
  "cdsActionType": {
    "alert": "警示",
    "warning": "警告",
    "hardStop": "强制停止",
    "suggestion": "建议",
    "notification": "通知"
  },
  "cdsRuleType": {
    "drugInteraction": "药物相互作用",
    "drugAllergy": "药物过敏",
    "duplicateOrder": "重复医嘱",
    "custom": "自定义",
    "clinicalAlert": "临床警示",
    "sepsisScreen": "脓毒症筛查"
  },
  "system": {
    "title": "系统配置",
    "subtitle": "应用设置、安全与系统运行状况",
    "restartServices": "重启服务",
    "restartToast": "重启服务（占位 - 需要确认）",
    "loadError": "加载系统配置失败",
    "section": {
      "systemInfo": "系统信息",
      "systemInfoDesc": "版本、运行时间与服务运行状况",
      "general": "常规设置",
      "generalDesc": "应用名称、时区与品牌",
      "security": "安全设置",
      "securityDesc": "密码策略、MFA 与会话管理",
      "notifications": "通知设置",
      "notificationsDesc": "电子邮件与短信网关配置",
      "integration": "集成默认值",
      "integrationDesc": "MLLP、FHIR 与 HL7 默认配置",
      "featureFlags": "功能开关",
      "featureFlagsDesc": "启用或禁用系统功能",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "版本",
      "uptime": "运行时间",
      "database": "数据库",
      "redis": "Redis",
      "microservices": "微服务",
      "conn": "连接"
    },
    "uptime": {
      "running": "运行中",
      "unknown": "未知",
      "up": "运行中"
    },
    "subsection": {
      "passwordPolicy": "密码策略",
      "mfa": "多因素认证",
      "sessionLockout": "会话与锁定",
      "emailConfig": "电子邮件配置",
      "smsGateway": "短信网关",
      "mllpDefaults": "MLLP 默认值",
      "fhirConfig": "FHIR 配置",
      "hl7Encoding": "HL7 v2 编码"
    },
    "fields": {
      "appName": "应用名称",
      "timezone": "时区",
      "dateFormat": "日期格式",
      "supportEmail": "支持邮箱",
      "logoUrl": "徽标 URL",
      "maintenanceMode": "维护模式（禁用用户访问）",
      "upload": "上传",
      "minPasswordLength": "最小密码长度",
      "passwordExpiry": "密码有效期（天）",
      "requireUppercase": "需要大写字母",
      "requireNumbers": "需要数字",
      "requireSpecialChars": "需要特殊字符",
      "enableMfa": "启用 MFA",
      "mfaMethod": "MFA 方式",
      "sessionTimeout": "会话超时（分钟）",
      "maxLoginAttempts": "最大登录尝试次数",
      "lockoutDuration": "锁定时长（分钟）",
      "smtpHost": "SMTP 主机",
      "smtpPort": "SMTP 端口",
      "smtpUser": "SMTP 用户",
      "fromEmail": "发件人邮箱",
      "useTls": "使用 TLS",
      "enabled": "已启用",
      "provider": "服务商",
      "fromNumber": "发件号码",
      "defaultPort": "默认端口",
      "timeoutSeconds": "超时（秒）",
      "retryCount": "重试次数",
      "fhirBaseUrl": "FHIR 基础 URL",
      "authMethod": "认证方式",
      "fieldSeparator": "字段分隔符",
      "encodingChars": "编码字符",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "亚洲/新加坡（UTC+8）",
        "hongKong": "亚洲/香港（UTC+8）",
        "kualaLumpur": "亚洲/吉隆坡（UTC+8）",
        "bangkok": "亚洲/曼谷（UTC+7）",
        "tokyo": "亚洲/东京（UTC+9）",
        "kolkata": "亚洲/加尔各答（UTC+5:30）",
        "sydney": "澳大利亚/悉尼（UTC+11）"
      },
      "mfa": {
        "totp": "TOTP（身份验证器应用）",
        "sms": "SMS",
        "email": "电子邮件"
      },
      "fhirAuth": {
        "none": "无",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "保存常规设置",
      "security": "保存安全设置",
      "notifications": "保存通知设置",
      "integration": "保存集成设置",
      "features": "保存功能开关",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "常规",
      "security": "安全",
      "notifications": "通知",
      "integration": "集成",
      "features": "功能开关",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "上传徽标（占位）",
      "saved": "{{section}}设置已成功保存",
      "saveFailed": "保存设置失败"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "患者合并",
        "description": "启用患者合并/取消合并功能"
      },
      "breakGlass": {
        "label": "紧急访问",
        "description": "允许对受限记录进行紧急覆盖"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "为外部系统暴露 FHIR R4 端点"
      },
      "smartApps": {
        "label": "SMART on FHIR 应用",
        "description": "允许第三方 SMART 应用连接"
      },
      "clinicalDecisionSupport": {
        "label": "临床决策支持",
        "description": "为医嘱录入启用 CDS 钩子"
      },
      "telemedicine": {
        "label": "远程医疗模块",
        "description": "视频会诊与远程监护"
      },
      "patientPortal": {
        "label": "患者门户",
        "description": "面向患者的记录与预约门户"
      },
      "analyticsDashboard": {
        "label": "分析仪表板",
        "description": "高级分析与报表仪表板"
      },
      "medicationBarcode": {
        "label": "药品条码扫描",
        "description": "用药管理的条码验证"
      },
      "autoCoding": {
        "label": "自动编码（ICD/CPT）",
        "description": "AI 辅助的诊断与操作编码"
      }
    }
  },
  "audit": {
    "title": "审计日志",
    "subtitle": "系统活动日志，包含详细的变更追踪",
    "exportCsv": "导出 CSV",
    "exportToast": "正在将 {{count}} 条审计记录导出为 CSV（占位）",
    "searchPlaceholder": "按用户搜索…",
    "advanced": "高级",
    "breakGlassOnly": "仅紧急访问",
    "fromTo": "起始 / 结束：",
    "fromDate": "起始日期",
    "toDate": "结束日期",
    "clearFilters": "清除所有筛选条件",
    "entriesFound": "找到 {{count}} 条记录",
    "noMatch": "没有符合筛选条件的审计记录",
    "viewDetails": "查看详情",
    "detail": {
      "title": "审计记录详情",
      "timestamp": "时间戳",
      "user": "用户",
      "action": "操作",
      "resource": "资源",
      "ipAddress": "IP 地址",
      "breakGlass": "紧急访问",
      "yes": "是",
      "no": "否",
      "details": "详情",
      "dataChanges": "数据变更",
      "before": "变更前",
      "after": "变更后",
      "result": "结果"
    },
    "columns": {
      "timestamp": "时间戳",
      "user": "用户",
      "action": "操作",
      "resource": "资源",
      "resourceId": "资源 ID",
      "ipAddress": "IP 地址",
      "details": "详情",
      "view": "查看"
    },
    "filter": {
      "action": {
        "all": "所有操作",
        "create": "创建",
        "read": "读取",
        "update": "更新",
        "delete": "删除",
        "login": "登录",
        "logout": "登出",
        "export": "导出",
        "breakGlass": "紧急访问"
      },
      "resource": {
        "all": "所有资源",
        "patient": "患者",
        "encounter": "就诊",
        "order": "医嘱",
        "result": "结果",
        "medication": "用药",
        "user": "用户",
        "system": "系统"
      }
    },
    "pagination": {
      "first": "首页",
      "last": "末页",
      "pageOf": "第 {{page}} 页，共 {{pages}} 页",
      "range": "{{from}}-{{to}}，共 {{total}}"
    }
  },
  "taxonomy": {
    "title": "临床分类体系",
    "subtitle": "服务线对相关临床服务进行分组(Cardiovascular → Cardiology、EP Lab、Heart Failure Clinic)。两者均纳入排程使用的服务 ↔ 地点分配矩阵。",
    "addServiceLine": "添加服务线",
    "addClinicalService": "添加临床服务",
    "tabs": {
      "serviceLines": "服务线",
      "clinicalServices": "临床服务"
    },
    "searchLines": "搜索服务线...",
    "searchServices": "搜索临床服务...",
    "empty": {
      "linesNone": "尚未配置服务线。",
      "linesNoMatch": "没有匹配的服务线。",
      "servicesNone": "尚未配置临床服务。",
      "servicesNoMatch": "没有匹配的临床服务。"
    },
    "columns": {
      "name": "名称",
      "code": "代码",
      "description": "描述",
      "services": "服务数",
      "status": "状态",
      "serviceLine": "服务线",
      "specialty": "专科",
      "actions": "操作"
    },
    "status": {
      "active": "启用",
      "inactive": "停用"
    },
    "editTitle": "编辑"
  },
  "systemStatus": {
    "connected": "已连接",
    "error": "错误"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "已配置 {{count}} 人",
      "unstaffedBadge": "无人员",
      "unstaffedWarning": "以下角色没有任何人员，相应级别将无法呼叫任何人：{{roles}}。请在“管理 → 用户”中为该角色分配人员。"
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
